'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _dropZoneUtils = require('./dropZoneUtils');

var _DropZone = require('./DropZone');

var _DropZone2 = _interopRequireDefault(_DropZone);

var _FileInput = require('./FileInput');

var _FileInput2 = _interopRequireDefault(_FileInput);

var _FileUploadingContainer = require('./FileUploadingContainer');

var _FileUploadingContainer2 = _interopRequireDefault(_FileUploadingContainer);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function FileSelect(props) {
  var error = props.error,
      hasBlur = props.hasBlur,
      id = props.id,
      isRequired = props.isRequired,
      name = props.name,
      value = props.value,
      rest = _objectWithoutProperties(props, ['error', 'hasBlur', 'id', 'isRequired', 'name', 'value']);

  var onSelect = (0, _dropZoneUtils.handleSelect)(props);
  return _react2.default.createElement('div', null, name && _react2.default.createElement('label', {
    htmlFor: id
  }, _react2.default.createElement('strong', null, name, isRequired ? '*' : false)), error && _react2.default.createElement('p', null, error), hasBlur && _react2.default.createElement('p', {
    className: 'uploading'
  }, 'Image Selected'), !hasBlur && _react2.default.createElement('div', null, _react2.default.createElement(_DropZone2.default, _extends({}, rest, {
    onSelect: onSelect
  })), _react2.default.createElement(_FileInput2.default, _extends({}, rest, {
    onSelect: onSelect
  }))), value && _react2.default.createElement(_FileUploadingContainer2.default, _extends({}, rest, {
    value: value
  })));
}

FileSelect.propTypes = {
  error: _propTypes2.default.string,
  hasBlur: _propTypes2.default.bool,
  id: _propTypes2.default.string,
  isRequired: _propTypes2.default.bool,
  name: _propTypes2.default.string,
  onSelect: _propTypes2.default.func,
  value: _propTypes2.default.shape({
    name: _propTypes2.default.string
  })
};
exports.default = FileSelect;
module.exports = exports['default'];